import { createAPI } from '@common'
export default {
  postE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60mjtuebub', 'post', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getMamVideoDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efubjm', 'GET', config, vconfig),
  // 音视频加锁
  putCommonLock: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0dpnnpo0mpdl', 'PUT', config, vconfig),
  // 音视频解锁
  putCommonUnlock: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0dpnnpo0vompdl', 'get', config, vconfig),
  // 视频送审（可以批量）
  processAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0qspdftt',
      'POST',
      config,
      vconfig
    ),
  // 新增审核意见
  addAuditIdeaAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0beeBvejuJefb',
      'POST',
      config,
      vconfig
    ),
  // 视频审核通过
  passAuditAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0qbttBveju',
      'POST',
      config,
      vconfig
    ),
  // 视频审核驳回
  notPassAuditAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0opuQbttBveju',
      'POST',
      config,
      vconfig
    ),
  // 查询审核记录
  getAuditIdeaAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0hfuBvejuJefb',
      'POST',
      config,
      vconfig
    ),
  // 修改审核意见
  updateAuditIdeaAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0vqebufBvejuJefb',
      'POST',
      config,
      vconfig
    ),
  // 删除审核意见
  deleteAuditIdeaAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0wjefpQspdftt0efmfufBvejuJefb',
      'POST',
      config,
      vconfig
    ),
  // 计审获取详情
  getInspectResult: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0jotqfdu0hfuSftvmu', 'POST', config, vconfig),
  // 获取当前转码服务厂商
  getTranscodeService: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0jotqfdu0hfuUsbotdpefTfswjdf',
      'POST',
      config,
      vconfig
    ),
  // 获取当前转码服务厂商
  getIsModifyTitle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0dpnnpo0jtNpejgzUjumf', 'GET', config, vconfig),
  // 删除前确认当前音视频是否属于档案
  deletePrompt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efmfufQspnqu', 'POST', config),
  // 删除视频
  deleteVideoDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efmfuf', 'POST', config),
  // 推送视频
  pushVideo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0dpnnpo0qvti', 'POST', config),
  // 上传视频失败重试
  againVideo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0usbotdpef0bhbjo', 'POST', config),
  // 版本视频详情
  getMamVideoDetailByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efubjmCzWfstjpo',
      'GET',
      config,
      vconfig
    ),
  postMamVideoDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0vqebufefubjm', 'POST', config),
  // 获取视频的标签
  getMamAiTag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0ubh', 'GET', config),
  // 腾讯云剪辑 从后台获取code
  getAuthorize: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0dvuujoh0bvuipsj{f', 'GET', config),
  // 腾讯云剪辑 获取平台id
  getPlatform: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0dvuujoh0hfuQmbugpsn', 'GET', config),
  // 音视频上线（可以批量）
  onlineProcessAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0bvejpQspdftt0pomjof', 'POST', config, vconfig),
  // 音视频下线（可以批量）
  offlineProcessAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0bvejpQspdftt0pggmjof',
      'POST',
      config,
      vconfig
    ),
  // 音频送审（可以批量）
  audioProcessAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0bvejpQspdftt0qspdftt',
      'POST',
      config,
      vconfig
    ),
  // 视频审核通过
  audioPassAuditAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0bvejpQspdftt0qbttBveju',
      'POST',
      config,
      vconfig
    ),
  // 视频审核驳回
  audioNotPassAuditAction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0bvejpQspdftt0opuQbttBveju',
      'POST',
      config,
      vconfig
    ),
  // 视频审核驳回
  videoRegisterLink: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0vqmpbe0sfhjtufs0mjol',
      'POST',
      config,
      vconfig
    ),

  // 下载审批
  getDownloadConditions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60dpoejujpot', 'GET', config),
  getDownloadList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60mjtut', 'GET', config),
  getDownloadListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60mjtuebub', 'POST', config),
  checkApplyDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0difdlBqqmz', 'GET', config),
  saveDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0tbwf', 'POST', config),
  auditDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0bveju', 'POST', config),
  saveEventStateDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0tbwfFwfouTubuf', 'GET', config),

  // 获取智能识别
  getMamAiAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0hfuWjefpEjtujohvjti',
      'POST',
      config
    ),
  // 获取智能识别
  getAudioAiAsync: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0hfuBvejpEjtujohvjti',
      'POST',
      config
    ),
  //人脸识别结果修改
  updateFace: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0vqebufGbdf', 'POST', config),
  //音频审核结果显示
  geAudioCensor: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0hfBvejpDfotps', 'POST', config),
  // 保存智能识别
  postMamAiAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0vqebufWjefpBP', 'POST', config),

  //mediax-video/v1/mam/video/ta
  // 修改视频的标签
  postMamAiTag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0vqebufWjefpUbh', 'POST', config),
  // 快编
  postMamFastUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0gbtuFeju', 'post', config),
  // 获取文件下载信息
  getMamDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0nbn0epxompbe', 'post', config),
  // 获取视频转码进度
  postMamTransPercent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0vqmpbe0usbot0qfsdfou', 'post', config, {
      neverLoading: true
    }),
  // 获取智能能力是否完成
  getIntellResult: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0hfuJoufmmSftvmu',
      'post',
      config,
      {
        neverLoading: true
      }
    ),
  // 删除视频
  deleteMamVideoDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efmfuf', 'DELETE', config),
  getMamE5Logs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60bdujpot0mpht', 'get', config, vconfig), // 日志
  // 热词权限(暂时没有)
  getMamAiPermissionWordAssociate: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0qfsnjttjpo0xpseBttpdjbuf', 'GET', config),

  // 编目基础信息查询/v1/mam/video/extfields
  getMamVideoExtfields: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20dbubMph0bmm', 'GET', config),
  // 编目基础信息值查询
  getMamExtfields: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20dbubMph', 'GET', config),
  // 开启音视频频检测
  postMamAiVideoAsyncscan: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0beeUbtl', 'post', config),
  //修改编目
  setMamExtfields: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20dbubMph0vqebuf', 'POST', config),

  // 删除单个视频文件
  deleteSingleFile: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0usbotGjmf0efm', 'post', config),
  // 视频截图信息删除
  postMamVideoPicsDel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0qjdt0efm', 'POST', config, {
      neverLoading: true
    }),
  // 视频截图信息修改
  postMamVideoPics: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0qjdt0psefs', 'POST', config, {
      neverLoading: true
    }),
  // 添加视频打点
  postMamVideoPoint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0qpjou', 'POST', config),
  // 删除视频打点
  postMamVideoPointDel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efmQpjou', 'POST', config),
  postMamVideoPointUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0vqebufQpjou', 'POST', config),
  postMamVideoSetCover: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0tfuDpwfs', 'POST', config),
  getVideoDownloadToken: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmft0xbo0epxompbe0uplfo', 'GET', config, {
      neverLoading: true, noHideLoading: true
    }),
  getVideoDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmft0xbo0epxompbe', 'GET', config, {
      neverLoading: true
    }),
  // 语音识别导出
  getMamVideoExportDistinguish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0fyqpsuEjtujohvjti',
      'GET',
      config
    ),
  // 语音识别导出
  getMamVideoSssLink: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmft0ptt0mjol', 'GET', config),
  // 手动签发音视频稿件
  postMamVideoPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0qvcmjti', 'POST', config),
  // 新建/修改智能签发任务
  postMamVideopubTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0qvcmjti0qvcUbtl', 'POST', config),
  // 删除智能签发任务
  delMamVideopubTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0qvcmjti0efmQvcUbtl', 'GET', config),
  // 获取任务下要签发的音视频列表
  getMamVideopubTaskList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0qvcmjti0hfuMjtu', 'GET', config)

  /* getGroups: (config) => createAPI('customEncryptApiName-1/0w20hspvqt', 'GET', config),
  // 获取上传到云视的accessToken
  // postMamUploadAccesstoken: config => createAPI('customEncryptApiName-1/0w20nbn0vqmpbe0bddfttuplfo', 'POST', config),
  postMamUploadAccesstoken: (config) =>
    createAPI(
      config.hubConfig
        ? 'CMS:/v1/mam/upload/accesstoken'
        : '/v1/mam/upload/accesstoken',
      'POST',
      { data: config.data },
      config.hubConfig ? { hubForward: true, hub: 'e5/hub' } : null
    ),

  // 云视上传成功回调
  // postMamMateriafileUpload: config => createAPI('customEncryptApiName-1/0w20nbn0nbufsjbgjmf0vqmpbe', 'POST', config),
  postMamMateriafileUpload: (config) =>
    createAPI(
      config.hubConfig
        ? 'CMS:/v1/mam/materiafile/upload'
        : '/v1/mam/materiafile/upload',
      'POST',
      { data: config.data },
      config.hubConfig ? { hubForward: true, hub: 'e5/hub' } : null
    ),

  
  
  
  getMamProcess: (config) => createAPI('customEncryptApiName-1/0w20nbn0qspdftt', 'GET', config),
  // 视频引用状态查询
  getMamVideoStatusUse: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0tubuvt0vtf', 'GET', config),
  
  
  // 编目信息修改
  postMamVideoExtfields: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0fyugjfmet', 'POST', config),
  // 素材引用
  getMamVideoMaterielUse: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0nbufsjfm0vtf', 'GET', config),
  
  // 传base64图片返回url
  postMamPhotoUploadfileBase64: (config) =>
    createAPI('customEncryptApiName-1/w20nbn0qipup0vqmpbegjmf0cbtf75', 'POST', config),
  // 获取base64Image
  getE5Images: (config) => createAPI('customEncryptApiName-1/0f60jnbhft', 'get', config),

  // 获取调用云视接口所需参数
  // getMamUploadAccessparam: config => createAPI('customEncryptApiName-1/0w20nbn0vqmpbe0bddfttqbsbn', 'GET', config),
  getMamUploadAccessparam: (config) =>
    createAPI(
      config.hubConfig
        ? 'CMS:/v1/mam/upload/accessparam'
        : '/v1/mam/upload/accessparam',
      'GET',
      { params: config.params },
      config.hubConfig ? { hubForward: true, hub: 'e5/hub' } : null
    ),

  // 资源加锁
  putMamLock: (config) => createAPI('customEncryptApiName-1/0w20nbn0mpdl', 'PUT', config),
  // 获取云视上传token
  postMamUploadForCMSAccesstoken: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0vqmpbeGpsDNT0bddfttuplfo', 'POST', config),
  // 发起获取视频获取字幕任务
  postMamVideoFreshenTxt: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0gsftifo0uyu', 'POST', config),
  // 开启音频检测
  postMamAiVideoAsyncscan: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0wjefp0btzodtdbo', 'post', config),
  // 获取视频音频的字幕列表
  getMamAiTxt: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0uyu', 'GET', config),
  // 修改音视频的字幕
  postMamAiTxt: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0uyu', 'POST', config),
  // 修改音视频的字幕
  getMamAiStatus: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0tubuvt', 'GET', config),
  // 获取视频的字幕列表
  getMamVideoTxt: (config) => createAPI('customEncryptApiName-1/0w20nbn0wjefp0uyu', 'GET', config),
  
  // 检测并发布内网图片
  postMamVideoIsExtracted: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0jtFyusbdufe', 'POST', config, {
      neverLoading: true
    }),
  
  // 敏感词检测
  postSensitiveCheck: (config) =>
    createAPI('customEncryptApiName-1/0w20tfotjujwf0difdl', 'post', config, { neverLoading: true }),
  getLeaderGroups: (config) => createAPI('customEncryptApiName-1/0w20mfbefs0hspvqt', 'GET', config),
  // 查询热词
  getAiWordAssociate: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0xpseBttpdjbuf', 'GET', config, {
      neverLoading: true
    }),
  // 查询人脸识别结果
  getMamAiFace: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0gbdf', 'GET', config),
  // 查询文字识别结果
  getMamAiOcr: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0pds', 'GET', config),
 

  // 获取压缩后的图片
  getMamPhotoCompress: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0dpnqsftt', 'GET', config),
  
  // 移动分组
  move: (config) => createAPI('customEncryptApiName-1/w20nbn0dpnnpo0npwf', 'POST', config),
  // 回退
  back: (config) => createAPI('customEncryptApiName-1/w20nbn0nbufsjbm0cbdl', 'POST', config) */
}
